import { render, staticRenderFns } from "./right-panel.vue?vue&type=template&id=bc4ba268&scoped=true"
import script from "./right-panel.vue?vue&type=script&lang=js"
export * from "./right-panel.vue?vue&type=script&lang=js"
import style0 from "./right-panel.vue?vue&type=style&index=0&id=bc4ba268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4ba268",
  null
  
)

export default component.exports